import { CXoneState } from '../../types';

export function buildCxoneInitSuccessState(): CXoneState {
  return {
    isInitialized: true,
    isConnecting: false,
    isConnected: true,
    connectionError: null,
    connectionProgress: null,
  };
}

export function buildCxoneVoiceConnectFailureState(error: string): CXoneState {
  return {
    isInitialized: false,
    isConnecting: false,
    isConnected: false,
    connectionError: error,
    connectionProgress: null,
  };
}

export function buildCxoneSessionConflictState(message: string): CXoneState {
  return {
    isInitialized: false,
    isConnecting: false,
    isConnected: false,
    connectionError: message,
    connectionProgress: null,
  };
}

export function buildCxoneInitFailureState(message: string): CXoneState {
  return {
    isInitialized: false,
    isConnecting: false,
    isConnected: false,
    connectionError: message,
    connectionProgress: null,
  };
}
